import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=6ab31efd&"
import script from "./TextareaField.vue?vue&type=script&lang=ts&"
export * from "./TextareaField.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports